/**
 * Extract human-readable messages from Stride API / RTK Query errors.
 */

export function formatApiMessage(message: unknown): string {
  if (typeof message === 'string') return message
  if (Array.isArray(message)) {
    return message.filter(m => typeof m === 'string').join('. ')
  }
  return ''
}

export function extractRtkErrorMessage(error: unknown): string {
  if (!error || typeof error !== 'object') {
    return 'Request failed. Please try again.'
  }

  const err = error as {
    status?: string | number
    data?: { message?: unknown; error?: string }
    error?: string
  }

  const fromData = formatApiMessage(err.data?.message)
  if (fromData) return fromData

  if (typeof err.data?.error === 'string') return err.data.error
  if (typeof err.error === 'string') {
    if (err.status === 'FETCH_ERROR') {
      return 'Cannot reach the API from the browser. In local dev, restart the dev server so the Vite proxy is active, or ask the API team to allow your origin in CORS.'
    }
    return err.error
  }

  if (err.status === 401) return 'Invalid email or password.'
  if (err.status === 403) return 'You do not have permission to perform this action.'
  if (typeof err.status === 'number' && err.status >= 500) {
    return 'Server error. Please try again later.'
  }

  return 'Request failed. Please try again.'
}

/** Message from axios- or RTK-shaped errors (legacy dashboard pages). */
export function getAxiosLikeErrorMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== 'object') return fallback
  const err = error as {
    response?: { data?: { message?: string } }
    data?: { message?: string }
    message?: string
  }
  return err.response?.data?.message || err.data?.message || err.message || fallback
}
